var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.title && _vm.preamble)?_c('div',{staticClass:"hiq-important-message-banner"},[_c('Message',{attrs:{"hash":_vm.hash}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }